import MenuPopupInstance from './menu-popup';
import Dropdown from './customDropdown';
import BookingForm from './booking'
import Swiper from "swiper/dist/js/swiper.min.js";
import {TweenLite} from "gsap/TweenLite";
import windowStore from '../store/windowStore'

export default class {
    constructor() {
        this.menuSlider = document.querySelector('.menu-slider__list');
        this.heroSlider = document.querySelector('.homepage-hero__container');
        this.typesSlider = document.querySelector('.homepage-menu-types__container');
        this.paginationSlider = document.querySelector('.menu-slider__pagination');
        this.textSliderContainer = document.querySelector('.homepage-menu__text-slider');
        this.showMoreBtn = document.querySelector('.homepage-reservation__more-btn');
        this.showMoreText = document.querySelector('.homepage-reservation__details');
        this.menuPopup = new MenuPopupInstance();
        // this.booking = new BookingForm();
    }

    // goToReservation() {
    //     const reservationSection = document.querySelector('#reservation');
    //     const btn = document.querySelector('.homepage-intro__reservation')
    //     btn.addEventListener('click', (e) => {
    //         e.preventDefault();
    //         const elemTop = reservationSection.getBoundingClientRect().top + window.pageYOffset ;
    //
    //         TweenMax.to(window, 0.4, {scrollTo: {y: elemTop, autoKill: false}});
    //     })
    // }

    // addMenuTabs() {
    //     this.textSlider = new Swiper(this.textSliderContainer, {
    //         speed: 900,
    //         allowTouchMove: false,
    //         effect: 'fade',
    //         fadeEffect: {
    //             crossFade: true
    //         }
    //     });

    //     const tabs = document.querySelectorAll('.homepage-menu__tab');
    //     let activeTab = document.querySelector('.homepage-menu__tab--active');

    //     Array.from(tabs).forEach((elem, i) => {
    //         elem.addEventListener('click', () => {
    //             activeTab.classList.remove('homepage-menu__tab--active')
    //             this.textSlider.slideTo(i)
    //             activeTab = elem;
    //             activeTab.classList.add('homepage-menu__tab--active')
    //         })
    //     })
    // }

    addHeroSlider() {
        const mySwiper = new Swiper(this.heroSlider, {
            speed: 800,
            effect: 'fade',
            autoplay: {
                delay: 4000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },


            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2
            },
            fadeEffect: {
                crossFade: true
            },
            loop: true,


        });
    }

    addMenuTypesSlider() {
        const typesMenuSwiper = new Swiper(this.typesSlider, {
          speed: 800,
          watchSlidesVisibility: true,
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: true,
          breakpoints: {
            767: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
          },
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
          fadeEffect: {
            crossFade: true,
          },
          loop: true,
          // dots: true,
          pagination: {
            el: '.menu-slider__pagination',
            // type: 'bullets',
            // clickable: true,
            // dynamicBullets: true,
            // renderBullet: function (index, className) {
            //   return `
            //     <span class="swiper-pagination-bullet swiper-pagination-bullet-active swiper-pagination-bullet-active-main">
            //         <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            //             <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            //                 <g id="CTA-Gallery" transform="translate(-712.000000, -790.000000)" fill="#5F4638">
            //                     <g id="Group-2" transform="translate(274.000000, 130.000000)">
            //                         <g id="Group" transform="translate(380.000000, 660.000000)">
            //                             <polygon id="Rectangle" transform="translate(66.331897, 7.985282) rotate(45.000000) translate(-66.331897, -7.985282) " points="60.6854507 2.3388348 71.9783441 2.3388348 71.9783441 13.6317282 60.6854507 13.6317282"></polygon>
            //                         </g>
            //                     </g>
            //                 </g>
            //             </g>
            //         </svg>
            //       </span>
            //   `;
            // },
          },
          navigation: {
            nextEl: '.homepage-menu-types__container .menu-slider__next',
            prevEl: '.homepage-menu-types__container .menu-slider__prev',
          },
        });
        // typesMenuSwiper.slideTo(1, false, false);
        
        // const showNavigationOnLaptop = () => {
        //   // if (window.innerWidth > 1024) {
        //   if (window.innerWidth <= 768) {
        //     const navigation = document.querySelector('.homepage-menu-types__container .menu-slider__navigation');

        //     navigation.style.cssText = `
        //       display: block;
        //       height: ${typesMenuSwiper.slides[0].clientHeight + 'px'};
        //     `;

        //     const setButtonOverlayHeight = () => {
        //       const navigationBtns = document.querySelectorAll('.homepage-menu-types__container .menu-slider__btn ');

        //       navigationBtns.forEach((btn) => {
        //         const imgLink = document.querySelector('.homepage-menu-types__container .menu-types__img-link');
        //         const imgLinkHeight = `${imgLink.clientHeight}px`;

        //         btn.style.setProperty('--button-overlay-height', imgLinkHeight);
        //       });
        //     };

        //     setButtonOverlayHeight();
        //   }
        // };

        // showNavigationOnLaptop();

        // window.addEventListener('resize', () => {
        //   showNavigationOnLaptop();
        // })

        // const bindEventsToNavigationBtns = () => {
        //   const prevBtn = document.querySelector('.homepage-menu-types__container .menu-slider__prev');
        //   const nextBtn = document.querySelector('.homepage-menu-types__container .menu-slider__next');

        //   prevBtn.addEventListener('click', () => {
        //     console.log('Click prev');
        //     typesMenuSwiper.slideNext();
        //     // typesMenuSwiper.slidePrev();
        //   });

        //   nextBtn.addEventListener('click', () => {
        //     console.log('Click next');
        //     // typesMenuSwiper.slideNext();
        //     typesMenuSwiper.slidePrev();
        //   });
        // }

        // bindEventsToNavigationBtns();

        // console.log(typesMenuSwiper.slides);

        const slides_ = document.querySelectorAll(
          '.homepage-menu-types__container .swiper-slide:not(.swiper-slide-duplicate)'
        );

        // console.log('slides_:', slides_);

        const menuBtns = document.querySelectorAll('.homepage-menu__show-menu');
        const menuImage = document.querySelectorAll('.menu-types__img-link');

        function menu_events(elements, menuPopup){
            Array.from(elements).forEach((elem) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();

                    const slide = e.currentTarget.closest('.homepage-menu-types__container .swiper-slide');
                    const slideIndex = slide.dataset.swiperSlideIndex;

                    // typesMenuSwiper.slideTo(index, false, false);

                    menuPopup.setActiveTab(slideIndex, 0);
                    menuPopup.open();
                })
            })
        }
        menu_events(menuImage, this.menuPopup);
        menu_events(menuBtns, this.menuPopup);
    }

    addMenuSlider() {
        const mySwiper = new Swiper(this.menuSlider, {
          speed: 800,
          effect: 'fade',
          preventClicks: false,
          preventClicksPropagation: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
          fadeEffect: {
            crossFade: true,
          },
          loop: true,
          // dots: true,
          pagination: {
            el: '.menu-slider__pagination',
            // type: 'bullets',
            //clickable: true,
            // dynamicBullets: true,
          },
        });

        const prevBtn = document.querySelector('.menu-slider .menu-slider__prev');
        const nextBtn = document.querySelector('.menu-slider .menu-slider__next');

        prevBtn.addEventListener('click', () => {
            mySwiper.slidePrev();
        })

        nextBtn.addEventListener('click', () => {
            mySwiper.slideNext();
        })
    }

    // addmenuTabsSlider() {
    //     const lol = new Swiper('.menu-tabs-slider', {
    //         speed: 400,
    //         freeMode: true,
    //         slidesPerView: 'auto',
    //         watchOverflow: true
    //     });
    // }

    addPaginationSlider() {
        const mySwiper = new Swiper(this.paginationSlider, {
          centeredSlides: true
        });

        console.log('pagination slider');
    }

    showMoreInfoForReservationOnClick() {
        if(!this.showMoreBtn) return;
        this.showMoreBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleShowMore('.homepage-reservation__details')
        })

        document.querySelector('body').addEventListener('click', (e) => {
            // if(e.target.classList.contains('homepage-reservation__details')) return
            this.closeShowMore('.homepage-reservation__details')
        })
    }

    closeShowMore() {
        this.showMoreText.classList.remove('homepage-reservation__details--active');
        this.showMoreBtn.classList.remove('homepage-reservation__more-btn--active');
    }

    openShowMore() {
        this.showMoreText.classList.add('homepage-reservation__details--active');
        this.showMoreBtn.classList.add('homepage-reservation__more-btn--active');
    }

    toggleShowMore() {
        this.showMoreText.classList.contains('homepage-reservation__details--active')
            ? this.closeShowMore()
            : this.openShowMore()
    }


    init() {
        // this.booking.init();
        this.showMoreInfoForReservationOnClick();
        this.addHeroSlider();
        // this.goToReservation();
        this.addMenuSlider();
        this.addMenuTypesSlider();
        this.addPaginationSlider();

        // this.addMenuTabs();
        this.menuPopup.init();
    }

}

function toggleElemClass(elemClass) {
    const elem = document.querySelector(elemClass);
    const activeClassName = `${elemClass.replace('.', '')}--active`;

    elem.classList.contains(activeClassName.replace('.'))
        ? elem.classList.remove(activeClassName)
        : elem.classList.add(activeClassName)
}

function menusTabsWidth() {
    let container = document.querySelector('.tabsContainer');
    let tabs = document.querySelector('.tabsArea');
    let arrow = document.querySelector('.callToScroll');
    if (!container || !tabs || !arrow) {
        return;
    }
    if (container.clientWidth <= tabs.clientWidth) {
        arrow.classList.add('big-count');
    } else {
        arrow.classList.remove('big-count');
    }
}

window.addEventListener('resize', function () {
    menusTabsWidth();
});

menusTabsWidth();
